import React, { useEffect, useState } from "react";
import useLocales from "../../../../hooks/useLocales";

const CountDownCard = ({ item, styles }) => {
  const { translate } = useLocales();
  const coloum_value = JSON.parse(item?.coloum_value);

  const [fonts, setFonts] = useState(styles?.filter((item) => item.coloum_name === "fonts")?.[0]);
  const [fontValue, setFontValue] = useState(null);
  
  useEffect(() => {
    setFonts(styles?.filter((item) => item.coloum_name === "fonts")?.[0]);
  }, [item, styles])

  useEffect(() => {
    if(fonts?.coloum_value){
      setFontValue(JSON.parse(fonts?.coloum_value));
    }
  }, [fonts])


  const targetDate = new Date(coloum_value?.coloum_value?.date);
  const targetTime = coloum_value?.coloum_value?.time;

  const [countdown, setCountdown] = useState(calculateCountdown());

  function calculateCountdown() {
    const now = new Date().getTime();
    const targetDateTime = new Date(
      `${targetDate.toDateString()} ${targetTime}`
    );
    const distance = targetDateTime - now;
    return distance > 0 ? distance : 0;
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(calculateCountdown());
    }, 1000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function formatTime(time) {
    const days = Math.floor(time / (1000 * 60 * 60 * 24))
      .toString()
      .padStart(2, "0");
    const hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      .toString()
      .padStart(2, "0");
    const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60))
      .toString()
      .padStart(2, "0");
    const seconds = Math.floor((time % (1000 * 60)) / 1000)
      .toString()
      .padStart(2, "0");

  
    return (
      <div className="flex gap-[16px] justify-center">
        <div>
          <div className="flex gap-[1px] ">
          <div style={{background:coloum_value?.coloum_value?.digitBgColor || '#00000066'}} className={`bg-[${coloum_value?.coloum_value?.digitBgColor || '#00000066'}] rounded-[4px] py-[5px] px-[6px] backdrop-blur-[2.5px]`}>
          <h1 style={{color:coloum_value?.coloum_value?.digitColor || '#fff'}} className={`text-custom_h6 text-[${coloum_value?.coloum_value?.digitColor || '#fff'}]`}>
                {days.slice(0, 1)}
              </h1>
            </div>
            <div style={{background:coloum_value?.coloum_value?.digitBgColor || '#00000066'}} className={`bg-[${coloum_value?.coloum_value?.digitBgColor || '#00000066'}] rounded-[4px] py-[5px] px-[6px] backdrop-blur-[2.5px]`}>
            <h1 style={{color:coloum_value?.coloum_value?.digitColor || '#fff'}} className={`text-custom_h6 text-[${coloum_value?.coloum_value?.digitColor || '#fff'}]`}>
                {days.slice(1, 2)}
              </h1>
            </div>
          </div>
          <p style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={`text-center text-small4_b mt-[5px] font-${fontValue?.fontType?.value}`}>
          {/* Days */}
            {translate("filtermodal.dayss")}
          </p>
        </div>
        <div>
          <div className="flex gap-[1px] ">
          <div style={{background:coloum_value?.coloum_value?.digitBgColor || '#00000066'}} className={`bg-[${coloum_value?.coloum_value?.digitBgColor || '#00000066'}] rounded-[4px] py-[5px] px-[6px] backdrop-blur-[2.5px]`}>
          <h1 style={{color:coloum_value?.coloum_value?.digitColor || '#fff'}} className={`text-custom_h6 text-[${coloum_value?.coloum_value?.digitColor || '#fff'}]`}>
                {hours.slice(0, 1)}
              </h1>
            </div>
            <div style={{background:coloum_value?.coloum_value?.digitBgColor || '#00000066'}} className={`bg-[${coloum_value?.coloum_value?.digitBgColor || '#00000066'}] rounded-[4px] py-[5px] px-[6px] backdrop-blur-[2.5px]`}>
            <h1 style={{color:coloum_value?.coloum_value?.digitColor || '#fff'}} className={`text-custom_h6 text-[${coloum_value?.coloum_value?.digitColor || '#fff'}]`}>
                {hours.slice(1, 2)}
              </h1>
            </div>
          </div>
          <p style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={`text-center text-small4_b mt-[5px] font-${fontValue?.fontType?.value}`}>
          {/* Hours */}
            {translate("cms.hours")}
          </p>
        </div>
        <div>
          <div className="flex gap-[1px]">
            <div style={{background:coloum_value?.coloum_value?.digitBgColor || '#00000066'}} className={`bg-[${coloum_value?.coloum_value?.digitBgColor || '#00000066'}] rounded-[4px] py-[5px] px-[6px] backdrop-blur-[2.5px]`}>
              <h1 style={{color:coloum_value?.coloum_value?.digitColor || '#fff'}} className={`text-custom_h6 text-[${coloum_value?.coloum_value?.digitColor || '#fff'}]`}>
                {minutes.slice(0, 1)}
              </h1>
            </div>
            <div style={{background:coloum_value?.coloum_value?.digitBgColor || '#00000066'}} className={`bg-[${coloum_value?.coloum_value?.digitBgColor || '#00000066'}] rounded-[4px] py-[5px] px-[6px] backdrop-blur-[2.5px]`}>
            <h1 style={{color:coloum_value?.coloum_value?.digitColor || '#fff'}} className={`text-custom_h6 text-[${coloum_value?.coloum_value?.digitColor || '#fff'}]`}>
                {minutes.slice(1, 2)}
              </h1>
            </div>
          </div>
          <p style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={`text-center text-small4_b mt-[5px] font-${fontValue?.fontType?.value}`}>
          {/* Minutes */}
            {translate("cms.minutes")}
          </p>
        </div>
        <div>
          <div className="flex gap-[1px] ">
          <div style={{background:coloum_value?.coloum_value?.digitBgColor || '#00000066'}} className={`bg-[${coloum_value?.coloum_value?.digitBgColor || '#00000066'}] rounded-[4px] py-[5px] px-[6px] backdrop-blur-[2.5px]`}>
          <h1 style={{color:coloum_value?.coloum_value?.digitColor || '#fff'}} className={`text-custom_h6 text-[${coloum_value?.coloum_value?.digitColor || '#fff'}]`}>
                {seconds.slice(0, 1)}
              </h1>
            </div>
            <div style={{background:coloum_value?.coloum_value?.digitBgColor || '#00000066'}} className={`bg-[${coloum_value?.coloum_value?.digitBgColor || '#00000066'}] rounded-[4px] py-[5px] px-[6px] backdrop-blur-[2.5px]`}>
            <h1 style={{color:coloum_value?.coloum_value?.digitColor || '#fff'}} className={`text-custom_h6 text-[${coloum_value?.coloum_value?.digitColor || '#fff'}]`}>
                {seconds.slice(1, 2)}
              </h1>
            </div>
          </div>
          <p style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={`text-center text-small4_b mt-[5px] font-${fontValue?.fontType?.value}`}>
          {/* Seconds */}
            {translate("cms.seconds")}
          </p>
        </div>
      </div>
    );
  }

  // console.log(formatTime(countdown), "count down");

  return (
    <div className="flex flex-col justify-center gap-[10px] ">
      <div>
        <p style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={`text-small3_b capitalize text-center font-${fontValue?.fontType?.value}`}>
          {coloum_value?.coloum_value?.description}
        </p>
      </div>
     
      {formatTime(countdown)}
    </div>
  );
};

export default CountDownCard;
